import { apiClient } from "@/api/client";
import type { ApiResponse } from "@/api/types";

/** Two-way calendar sync (E14): the caller's own Google / Microsoft 365 connections. */
export type CalendarProviderKey = "GOOGLE" | "OUTLOOK";

export interface MyCalendarConnections {
  direction: "TWO_WAY";
  changeNotifications: boolean;
  note: string;
  providers: { key: CalendarProviderKey; label: string; configured: boolean; missing: string[] }[];
  connections: {
    provider: CalendarProviderKey; label: string; configured: boolean;
    status: "NOT_CONNECTED" | "CONNECTED" | "REVOKED" | "ERROR";
    accountEmail: string | null; connectedOn: string | null; lastSyncedAt: string | null; lastError: string | null; watching: boolean;
  }[];
}

const unwrap = async <T,>(p: Promise<{ data: ApiResponse<T> }>) => (await p).data.data;
const path = (p: CalendarProviderKey) => p.toLowerCase();

/** Where the OAuth return page sends the person back to. Session-scoped: one tab, one attempt. */
export const RETURN_KEY = "bp-calendar-return";

export const calendarSyncService = {
  mine: () => unwrap(apiClient.get<ApiResponse<MyCalendarConnections>>("/me/calendar")),
  connect: (p: CalendarProviderKey) => unwrap(apiClient.post<ApiResponse<{ url: string }>>(`/me/calendar/${path(p)}/connect`, {})),
  callback: (p: string, code: string, state: string) => unwrap(apiClient.post<ApiResponse<{ connected: boolean; accountEmail: string | null }>>(`/me/calendar/${p.toLowerCase()}/callback`, { code, state })),
  disconnect: (p: CalendarProviderKey) => unwrap(apiClient.post<ApiResponse<{ connected: boolean }>>(`/me/calendar/${path(p)}/disconnect`, {})),
  syncNow: (p: CalendarProviderKey) => unwrap(apiClient.post<ApiResponse<{ requested: boolean }>>(`/me/calendar/${path(p)}/sync-now`, {})),
};
